import { PrismicImage, PrismicPageDefinition, PrismicRichText } from "./types";
import { TypeFaq_items } from "./pricing";

export type TypeDependencyTrackService = {
  service_image: PrismicImage;
  service_title: string;
  service_description: string;
};

export type TypeDependencyTrackServiceLower = {
  service_image_lower: PrismicImage;
  service_title_lower: string;
  service_description_lower: string;
};

export type TypeDependencyTrackPage = {
  title: PrismicRichText;
  meta_title: string;
  subtitle: PrismicRichText;

  section_title: string;
  section_title1: string;
  section_title2: string;
  section_title_lower: string;
  section_subtitle_lower: PrismicRichText;

  section_subtitle: PrismicRichText;
  section_subtitle1: PrismicRichText;
  section_text: PrismicRichText;
  section_text1: PrismicRichText;

  cta: string;
  subtitle1: string;
  button_text: string;
  button_link: PrismicPageDefinition;
  second_button_text: string;
  second_button_link: PrismicPageDefinition;

  services: TypeDependencyTrackService[];
  services_lower: TypeDependencyTrackServiceLower[];

  hero_image: PrismicImage;
  image: PrismicImage;
  image1: PrismicImage;
  image_plans: PrismicImage;
  plans_subtext: PrismicRichText;

  page_meta_title: string;
  page_meta_thumbnail: PrismicImage;
  page_meta_description: string;

  faqs_section_heading: string;
  faq_items: TypeFaq_items[];
};

export type TypeDependencyTrackQueryResult = {
  allPrismicDependencyTrack: {
    edges: Array<{
      node: { data: TypeDependencyTrackPage };
    }>;
  };
};

export const getPage = (
  data: TypeDependencyTrackQueryResult
): TypeDependencyTrackPage => {
  return data.allPrismicDependencyTrack.edges[0].node.data;
};
